import PrePurchaseFarePricesService from 'js/services/api/ticketing/pre-purchase-fare-prices'

import Fare from '../_fare'
import FareModal from '../_fare-modal'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  components: {Fare, FareModal},

  props: {
    fares: {
      type: Array,
      default: () => []
    },
    tabIndexInit: null,
  },

  data() {
    return {
      prices: [],
      selectedFare: {},
      showModal: false
    }
  },

  computed: {
    prePurchaseFareIds() {
      return this.fares.map(f => f.id)
    },

    faresPrices() {
      return this.fares.map(fare => {
        const price = this.findPrice(fare.id)
        return {...fare, price}
      })
    },

    filteredFaresPrices() {
      return this.faresPrices.filter(f => f.price)
    },

    orderedFaresPrices() {
      return _.sortBy(this.filteredFaresPrices, 'price')
    }
  },

  created() {
    this.getPrePurchaseFarePrices()
    //this.customAccesibilityTabs.setup(this.$options.name)
    //console.log("this.tabIndexInit",this.tabIndexInit);
  },
  mounted(){
    this.customAccesibilityTabs.setup(this.$options.name)
  },
  methods: {
    async getPrePurchaseFarePrices() {
      const params = {per: '0', pre_purchase_fare_ids: this.prePurchaseFareIds, distance: 1}
      const {data} = await PrePurchaseFarePricesService.index(params)
      this.prices = data
    },

    toggleModal(fare = null) {
      this.showModal = !this.showModal
      this.selectedFare = fare
    },

    findPrice(fareId) {
      const price = this.prices.find(p => p.pre_purchase_fare_id === fareId)
      return price ? price.price : 0
    }
  }
})
